<template>
  <span
    v-if="visible"
    class="asBadge"
    :class="{ '-dot': dot, '-inline': inline }"
  >
    <template v-if="!dot">{{ displayValue }}</template>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  count?: number
  dot?: boolean
  max?: number
  inline?: boolean
  showZero?: boolean
}>(), {
  count: 0,
  dot: false,
  max: 99,
  inline: false,
  showZero: false
})

const visible = computed(() => {
  if (props.dot) return props.count > 0 || props.showZero
  return props.count > 0 || props.showZero
})

const displayValue = computed(() => {
  if (props.count > props.max) return `${props.max}+`
  return String(props.count)
})
</script>

<style lang="scss" scoped>
@import "@vars";
@import '~@web/assets/scss/textContsnts.scss';

.asBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  padding: 4px 8px;
  background-color: var(--ac-color-deep-liliac);
  color: var(--ac-color-white);
  border-radius: 32px;
  @extend .text-sm;

  @media (min-width: $bp-desktop) {
    min-width: 20px;
    height: 20px;
    @include text-size(12px, 1);
    padding: 2px 6px;
  }

  &.-dot {
    width: 8px;
    height: 8px;
    min-width: 8px;
    padding: 0;
    border-radius: 50%;
  }

  &.-inline {
    margin-left: 6px;
  }
}
</style>
